<template>

  <div class="container">
    <div class="row align-items-center justify-content-center justify-content-lg-between">

      <div class="col-10 col-lg-5">
        <h2 class="welcome__heading display-1"> Welkom bij de <br>Veense Veiling </h2>
        <br>
        <br>
        <h3 class="welcome__subheading display-2"> Scan de QR code<br> of ga naar:<br> klok.veenseveiling.nl </h3>
      </div>

      <div class="col-4 col-lg-3 pe-5 pe-lg-0 pt-5 pt-lg-0 pb-5 pb-lg-0">
        <div class="bg-light rounded-5 p-5">
          <img class="welcome__img img-fluid w-100" src="/img/qr-code.svg" alt="img-title">
        </div>
      </div>

      <div class="row col-12 col-lg-3">
        <div v-for="user in users" class="d-flex flex-row align-items-center gap-1 animate-pulse w-auto text-break m-1 p-1 bg-dark" :id="'user-' + user.id">
          <div :id="'name' + user.id">
            {{ user.name }}
          </div>

          <svg v-if="!user.flic" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
            <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
          </svg>

          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
          </svg>
        </div>
      </div>

    </div>
  </div>

</template>

<style>
.pulse{
animation: pulse 0.5s ease-in-out;
}

@keyframes pulse{
0%{
  scale: 1;
}
50%{
  scale: 1.3;
}
100%{
  scale: 1;
}
}
</style>

<script setup>
import { onMounted, ref } from 'vue';

const users = ref([]);
const buttonUsers = ref([]);

onMounted(() => {
  setInterval(listen(), 200);
  axios.get("/api/buttonUsers").then(response => {
    buttonUsers.value = response.data.attendees;
  });
});

function listen(){
  // const listen = Echo.channel('auction-channel-' + getAuctionIdFromUrl())
  //     .listen('.flic.test', (attendee) => {
  //       attendee.attendee = {
  //         ...attendee.attendee,
  //         "flic": true,
  //       }

  //       userTest(attendee.attendee);
  //     })
  //     .listen('.flic.press', (e) => {
  //       console.log('testing');
  //       getButtonUser(e);
  //     })

  const listen2 = Echo.channel('auction-channel-all')
      .listen('.flic.press', (e) => {
        getButtonUser(e);
      })
    
  const event = Echo.private('auction-channel-' + getAuctionIdFromUrl())
      .listenForWhisper('phoneTest', (attendee) => {
        attendee = {
          ...attendee,
          "flic": false,
        }

        userTest(attendee);
      })
}

function userTest(attendee){
  axios.get("/api/buttonUsers").then(response => {
    buttonUsers.value = response.data.attendees;

    if(document.getElementById("user-" + attendee.id) != null){
      const el = document.getElementById("user-" + attendee.id);

      document.getElementById("name" + attendee.id).innerHTML = attendee.name;

      if(el.classList.contains("pulse")){
        return;
      }

      el.classList.add("pulse");

      setTimeout(() => {
        el.classList.remove("pulse");
      }, 600);

      return;
    }
    users.value.push(attendee);
  });
}

function getAuctionIdFromUrl(){
  return parseInt(window.location.pathname.split('/')[2]);
}

function getButtonUser(e){
  let number = e.number;
  let user = null;
  let userDetected = false;

  buttonUsers.value.forEach((buttonUser) => {
    if(buttonUser.number == number){
      userDetected = true;
      user = buttonUser;

      user = {
        ...user,
        "flic": true
      }

      userTest(user);
    }
  })

  if(userDetected == false){
    axios.post("/api/createButtonUser", {
      "name": `koper${number}`,
      "number": number,
      "auction_id": getAuctionIdFromUrl()
    }).then(response => {
      if(response.data.status == 500){
        return;
      }
      buttonUsers.value = response.data.attendees;
      response.data.attendees.forEach((attendee) => {
        if(attendee.number == number){
          user = attendee;

          user = {
            ...user,
            "flic": true
          }

          userTest(user);
        }
      })
    })
  }

  return user;
}
</script>

